import {createContext} from 'react'

const CatTipoMedicoContext = createContext()

export default CatTipoMedicoContext